export default __webpack_public_path__ + "static/media/advantage-5.db008b43.png";